import { _ } from "core-js";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "loading",
    "emailInput",
    "fullName",
    "gender",
    "cpf",
    "cro",
    "phoneNumber",
    "sameEstablishmentAlert"
  ];

  connect() {
    this.handleThrottle = _.throttle(() => this.verifyIfHasAccount(), 500);
  }

  handle() {
    this.showLoading();
    this.handleThrottle();
  }

  verifyIfHasAccount() {
    const email = this.emailInputTarget.value;

    if (!email) {
      this.hideLoading();
      this.cleanFields();
      return;
    }

    if (!this.isEmailValid(email)) {
      return;
    }

    this.markAllFieldsAsDisabled();

    fetch("/professionals/verify-has-account?email=" + encodeURI(email), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        this.toggleSameEstablishmentAlert(data.is_same_establishment);

        if (data.has_account) {
          this.fullNameTarget.value = data.full_name;
          this.genderTarget.value = data.gender;
          this.cpfTarget.value = data.cpf;
          this.croTarget.value = data.cro;
          this.phoneNumberTarget.value = data.phone_number;
          this.markAllFieldsAsDisabled();
          this.hideLoading();
          return;
        }

        this.cleanFields();
        this.removeDisableAllFields();
        this.hideLoading();
      })
      .catch(error => console.error(error));
  }

  markAllFieldsAsDisabled() {
    this.fullNameTarget.setAttribute("disabled", "");
    this.genderTarget.setAttribute("disabled", "");
    this.cpfTarget.setAttribute("disabled", "");
    this.croTarget.setAttribute("disabled", "");
    this.phoneNumberTarget.setAttribute("disabled", "");
  }

  removeDisableAllFields() {
    this.fullNameTarget.removeAttribute("disabled");
    this.genderTarget.removeAttribute("disabled");
    this.cpfTarget.removeAttribute("disabled");
    this.croTarget.removeAttribute("disabled");
    this.phoneNumberTarget.removeAttribute("disabled");
  }

  cleanFields() {
    this.fullNameTarget.value = null;
    this.genderTarget.value = null;
    this.cpfTarget.value = null;
    this.croTarget.value = null;
    this.phoneNumberTarget.value = null;
  }

  hideLoading() {
    this.loadingTarget.classList.add("tw-hidden");
  }

  showLoading() {
    this.loadingTarget.classList.remove("tw-hidden");
  }

  toggleSameEstablishmentAlert(show) {
    if (show) {
      this.sameEstablishmentAlertTarget.classList.remove("tw-hidden");
      return;
    }

    this.sameEstablishmentAlertTarget.classList.add("tw-hidden");
  }

  isEmailValid(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }
}
